import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { WorkflowComponent } from './workflow/workflow/workflow.component';
import { OpenAccessComponent } from './general-page/external-access/open-access/open-access.component';
import { QuotationPageGeneralComponent } from './quotation/quotation-page-general/quotation-page-general.component';
import { BoardsComponent } from './boards/boards.component/boards.component';
import { ExpiredPortfolioComponent } from './expired-portfolio/expired-portfolio.component/expired-portfolio.component';
import { ChangePasswordComponent } from './login/change-password.component/change-password.component';
import { LeaseLineComponent } from './quotation/lease-line/lease-line.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'changePassword/:token', component: ChangePasswordComponent },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: 'workflow',
    component: WorkflowComponent,
  },
  {
    path: 'boards',
    component: BoardsComponent,
  },
  {
    path: 'expired-portfolio',
    component: ExpiredPortfolioComponent,
  },
  {
    path: 'active-portfolio',
    loadChildren: () => import('./active-portfolio/active-portfolio.routes').then((m) => m.routes),
  },
  {
    path: 'catalogs',
    loadChildren: () => import('./catalogs/catalogs.routes').then((m) => m.routes),
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.routes').then((m) => m.routes),
  },
  {
    path: 'configuration',
    loadChildren: () => import('./general-page/general-page.routes').then((m) => m.routes),
  },
  { path: 'external-access', component: OpenAccessComponent },
  { path: 'quotation', component: QuotationPageGeneralComponent, canActivate: [AuthGuard] },
  { path: 'lease-line', component: LeaseLineComponent },
  {
    path: 'reportes',
    loadChildren: () => import('./reportes/reportes.routes').then((m) => m.routes),
  },
];
